import { render } from "./BorrowerCharacteristics.vue?vue&type=template&id=f6499fa2"
import script from "./BorrowerCharacteristics.vue?vue&type=script&lang=js"
export * from "./BorrowerCharacteristics.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/compare-loans.org/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__